export default {
  SEARCH_RESULT_LOADING_IN_PROCESS: 'SEARCH_RESULT_LOADING_IN_PROCESS',
  SEARCH_RESULT_LOADING_SUCCESS: 'SEARCH_RESULT_LOADING_SUCCESS',
  SEARCH_RESULT_LOADING_FAILED: 'SEARCH_RESULT_LOADING_FAILED',
};
